import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { SimulationTemplatesListRequest, Template } from "@nens/threedi/openapi-client";

import { getSimulationTemplatesApi } from "../apiConfiguration";

const simulationTemplatesApi = getSimulationTemplatesApi();

export function useSimulationTemplates(
  threediModelId: number,
  // Passs options -- used for pagination
  options: Partial<SimulationTemplatesListRequest> = {}
) {
  return useQuery({
    queryKey: ["simulationTemplates", threediModelId, options],
    queryFn: () =>
      simulationTemplatesApi.simulationTemplatesList({
        simulationThreedimodelId: threediModelId,
        ...options,
      }),
  });
}

// The below hook returns a function that can delete a Template, and if successful
// update the state of the useSimulationTemplates hook as well.
export function useDeleteSimulationTemplate(threediModelId: number) {
  const queryClient = useQueryClient();

  const mutate = useMutation({
    mutationFn: async (template: Template) => {
      const simulationTemplate = await simulationTemplatesApi.simulationTemplatesDelete({
        id: template.id!,
      });
      // Note that we could use queryClient.setQueryData here to set the new list
      // of templates immediately, but we don't because of pagination. Instead we invalidate
      // all pages of this model and let them be re-fetched.
      // This queryKey is a *prefix* of the one in useSimulationTemplates, and thus it
      // will invalidate all different options (that are used for pagination).
      const queryKey = ["simulationTemplates", threediModelId];
      queryClient.invalidateQueries({ queryKey });
      return simulationTemplate;
    },
  });

  // Rename the mutate.mutate function to something useful, pass other properties
  // like isSuccess as-is.
  return { ...mutate, deleteSimulationTemplate: mutate.mutate };
}
